export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/contact-banner.e7a27623-9f1507.png";